import React from 'react';
import { AdminNavLinkIcon, AnalyticsNavLinkIcon, EnrichNavLinkIcon, MerchandisingNavLinkIcon, SeoNavLinkIcon, } from '@/components/icons';
import { SectionPath } from '@/constants';
import { useSessionAreaName, useSessionCollectionName } from '@/platform-services/session';
import { useLocalization } from '@/localization';
import { NavigationListItem } from './navigation-list-item.component';
import { getSectionRoutes } from '@/navigation/drawer/lib/utils';
import { getDefaultRoute, getSectionLink } from '@/navigation/drawer/lib';
const NavIcon = ({ section }) => {
    const { path } = section;
    switch (path) {
        case SectionPath.ANALYTICS:
            return <AnalyticsNavLinkIcon />;
        case SectionPath.MERCHANDISING:
            return <MerchandisingNavLinkIcon />;
        case SectionPath.ADMIN:
            return <AdminNavLinkIcon />;
        case SectionPath.ENRICH:
            return <EnrichNavLinkIcon />;
        case SectionPath.SEO_STUDIO:
            return <SeoNavLinkIcon />;
        default:
            return null;
    }
};
export const PrimaryDrawerSectionLink = ({ active = false, section, onClick, }) => {
    const { formatMessage: t } = useLocalization();
    const activeCollection = useSessionCollectionName();
    const activeArea = useSessionAreaName();
    const routes = getSectionRoutes(section);
    if (!(routes === null || routes === void 0 ? void 0 : routes.length) && !section.showAlways) {
        return null;
    }
    const defaultRoute = getDefaultRoute(routes);
    const sectionLink = getSectionLink(section.path, defaultRoute, activeCollection, activeArea);
    const handleClick = () => onClick(section, sectionLink);
    const isDisabled = !section.showAlways && (section.disabled || !defaultRoute);
    return (<NavigationListItem active={active} text={t({ key: (section.label) })} icon={<NavIcon section={section}/>} onClick={handleClick} hasSubNav={Boolean(routes.length)} disabled={isDisabled}/>);
};
export default PrimaryDrawerSectionLink;
